import { render, staticRenderFns } from "./BasketPricesRowV2.vue?vue&type=template&id=aaff1ea2&"
import script from "./BasketPricesRowV2.vue?vue&type=script&lang=js&"
export * from "./BasketPricesRowV2.vue?vue&type=script&lang=js&"
import style0 from "./BasketPricesRowV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports